webpackJsonp([36],{

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Username, Email"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.firstName)+" "+_vm._s(item.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{ 'sts-danger': !_vm.userItemContainSelector(item) }},[_vm._v("\n                  "+_vm._s(_vm.printSelectorIndicator(item.selectors))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":item.isRoot},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item.id)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(item.isSyncWithAuth && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetPassword(item)}}},[_c('span',[_vm._v("Reset")])]):_vm._e(),_vm._v(" "),(!item.isSyncWithAuth && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.openAuthModal(item)}}},[_c('span',[_vm._v("Sync")])]):_vm._e(),_vm._v(" "),(
                        _vm.isAllowToDelete &&
                        (!item.isRoot || !_vm.isHimSelf(item.username))
                      )?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"usermodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("User")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-user-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'role' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-user-role","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'role'}}},[_c('span',{staticClass:"required"},[_vm._v("Roles")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'policy' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-user-policy","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'policy'}}},[_c('span',[_vm._v("Policies")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'selector' ? 'active' : '']},[_c('a',{attrs:{"href":"#identity-user-selector","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'selector'}}},[_c('span',[_vm._v("Selector")])])])]),_vm._v(" "),(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"identity-user-general"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Username")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.username),expression:"model.username"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.username.$error,
                              },attrs:{"type":"text","disabled":_vm.isUpdate},domProps:{"value":(_vm.model.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "username", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.username.$error)?_c('div',[(!_vm.$v.model.username.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Username is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.username.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Username must be less than\n                                "+_vm._s(_vm.$v.model.username.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),(!_vm.isUpdate)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.password.$error,
                              },attrs:{"type":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.password.$error)?_c('div',[(!_vm.$v.model.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                                "+_vm._s(_vm.$v.model.password.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.firstName.$error,
                              },attrs:{"type":"text"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.firstName.$error)?_c('div',[(!_vm.$v.model.firstName.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("First Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.firstName.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("First Name must be less than\n                                "+_vm._s(_vm.$v.model.firstName.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.lastName.$error,
                              },attrs:{"type":"text"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && !_vm.$v.model.lastName.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Last Name must be less than\n                              "+_vm._s(_vm.$v.model.lastName.$params.maxLength.max)+"\n                              characters")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Middle Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.middleName),expression:"model.middleName"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.middleName.$error,
                              },attrs:{"type":"text"},domProps:{"value":(_vm.model.middleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "middleName", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && !_vm.$v.model.middleName.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Middle Name must be less than\n                              "+_vm._s(_vm.$v.model.middleName.$params.maxLength.max)+"\n                              characters")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.email.$error,
                              },attrs:{"type":"text"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.email.$error)?_c('div',[(!_vm.$v.model.email.email)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.email.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                                "+_vm._s(_vm.$v.model.email.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Phone Code","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; }},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                        "+_vm._s(option.country)+"\n                                      ")])])]}}]),model:{value:(_vm.model.phoneCode),callback:function ($$v) {_vm.$set(_vm.model, "phoneCode", $$v)},expression:"model.phoneCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sanitizePhoneNumber),expression:"sanitizePhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.phoneNumber.$error,
                                  },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.sanitizePhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sanitizePhoneNumber=$event.target.value}}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.phoneNumber.maxLength
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                  "+_vm._s(_vm.$v.model.phoneNumber.$params.maxLength.max)+"\n                                  characters")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Image URI")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.imageUri),expression:"model.imageUri"}],staticClass:"form-control",attrs:{"type":"text","name":"imageUri"},domProps:{"value":(_vm.model.imageUri)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "imageUri", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Landing Page")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"label","options":_vm.landingPages,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.url; }},model:{value:(_vm.model.landingPage),callback:function ($$v) {_vm.$set(_vm.model, "landingPage", $$v)},expression:"model.landingPage"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'role' ? 'in active' : ''],attrs:{"id":"identity-user-role"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},_vm._l((_vm.model.modifiedRoles),function(item){return _c('label',{key:item.id,staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              "+_vm._s(item.name)+"\n                            ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'policy' ? 'in active' : ''],attrs:{"id":"identity-user-policy"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},_vm._l((_vm.model.modifiedPolicies),function(item){return _c('label',{key:item.id,staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              "+_vm._s(item.name)+"\n                            ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'selector' ? 'in active' : ''],attrs:{"id":"identity-user-selector"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Provider")]),_vm._v(" "),_c('multiselect',{attrs:{"group-values":"items","group-label":"group","placeholder":"Select provider","track-by":"id","label":"name","selectGroupLabel":"Press enter to select all","deselectGroupLabel":"Press enter to deselect all","options":_vm.providers,"multiple":true,"limit":1,"group-select":true},model:{value:(_vm.model.modifiedProviders),callback:function ($$v) {_vm.$set(_vm.model, "modifiedProviders", $$v)},expression:"model.modifiedProviders"}},[_c('span',{staticClass:"sts-danger",attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Sorry, no matching options.")])])],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company")]),_vm._v(" "),_c('multiselect',{attrs:{"group-values":"items","group-label":"group","placeholder":"Select company","track-by":"id","label":"name","selectGroupLabel":"Press enter to select all","deselectGroupLabel":"Press enter to deselect all","options":_vm.companies,"multiple":true,"limit":1,"group-select":true},model:{value:(_vm.model.modifiedCompanies),callback:function ($$v) {_vm.$set(_vm.model, "modifiedCompanies", $$v)},expression:"model.modifiedCompanies"}},[_c('span',{staticClass:"sts-danger",attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Sorry, no matching options.")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"userpasswordmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.changePasswordModel.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.changePassword()}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.changePasswordModel.password),expression:"changePasswordModel.password"}],staticClass:"form-control",class:{
                        'field-error':
                          _vm.isSubmitted &&
                          _vm.$v.changePasswordModel.password.$error,
                      },attrs:{"type":"password"},domProps:{"value":(_vm.changePasswordModel.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.changePasswordModel, "password", $event.target.value)}}}),_vm._v(" "),(
                        _vm.isSubmitted && _vm.$v.changePasswordModel.password.$error
                      )?_c('div',[(!_vm.$v.changePasswordModel.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.changePasswordModel.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                        "+_vm._s(_vm.$v.changePasswordModel.password.$params.maxLength
                            .max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(5)])])])])])])])]),_vm._v(" "),_c('div',{ref:"useridpasswordmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[(_vm.$v.auth.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAuth()}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.auth.password),expression:"auth.password"}],staticClass:"form-control",class:{
                        'field-error': _vm.isSubmitted && _vm.$v.auth.password.$error,
                      },attrs:{"type":"password"},domProps:{"value":(_vm.auth.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.auth, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.auth.password.$error)?_c('div',[(!_vm.$v.auth.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.auth.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                        "+_vm._s(_vm.$v.auth.password.$params.maxLength.max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(7)])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Security")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Users\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Users\n                  "),_c('span',[_c('i',{staticClass:"ic-settings-horizontal"})])]),_vm._v(" "),_c('p',[_vm._v("Create and manage application users.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Full Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Selector")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Change Password")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      Change Password\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("User Synchronization")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      Sync\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentityUser_vue__ = __webpack_require__(798);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d316124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentityUser_vue__ = __webpack_require__(1068);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IdentityUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d316124_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IdentityUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(500);




var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActiveWoSubscriber: function getAllActiveWoSubscriber() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/activewosubscriber').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getMasterOperators: function getMasterOperators(onBeginCallback, onFinallyCallback) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* asyncApi */].get(endpoint + '/list/master-operator', onBeginCallback, onFinallyCallback));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/identityPolicies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/identityRoles';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllPredefined: function getAllPredefined() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/predefined').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_identity_identityPolicyService_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_provider_providerService_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_company_companyService_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_countryPhoneService_js__ = __webpack_require__(532);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_DeleteModal__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    validationRulePassword: function validationRulePassword() {
      return !this.isUpdate ? { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) } : {};
    },
    sanitizePhoneNumber: {
      get: function get() {
        return this.model.phoneNumber;
      },
      set: function set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      }
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100]
      },
      isSubmitted: false,
      activeTab: "general",
      allPermissions: [],
      roles: [],
      policies: [],
      providers: [{ group: "Select all", items: [] }],
      companies: [{ group: "Select all", items: [] }],
      landingPages: [],
      phoneCodes: [],
      profile: null,
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      model: {},
      auth: {},
      changePasswordModel: {
        isMobile: false,
        id: "",
        changePasswordId: "",
        password: ""
      },
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        username: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
        password: this.validationRulePassword,
        firstName: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(50) },
        middleName: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(50) },
        lastName: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(50) },
        email: { email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) },
        phoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(20) }
      },
      changePasswordModel: {
        password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      },
      auth: {
        password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, permissions;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              _this.profile = _context.sent;
              permissions = _this.profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 25;
                break;
              }

              _context.next = 13;
              return _this.getAll();

            case 13:
              _context.next = 15;
              return _this.getPhoneCodes();

            case 15:
              _context.next = 17;
              return _this.getRoles();

            case 17:
              _context.next = 19;
              return _this.getPolicies();

            case 19:
              _context.next = 21;
              return _this.getProviders();

            case 21:
              _context.next = 23;
              return _this.getCompanies();

            case 23:
              _context.next = 25;
              return _this.getPredefinedLandingPages();

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.usermodal).on("hidden.bs.modal", this.closeModal);
  },
  updated: function updated() {
    this.$helper.collapseMenu("security");
    this.$helper.setNavigationClass("identity-user-link");
    this.$helper.numbersOnly();
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.table.pageNumber = 1;
                _context2.next = 3;
                return _this2.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this3;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this4.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    resetModel: function resetModel() {
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.changePasswordModel.$reset();
      this.$v.auth.$reset();
    },
    openModal: function openModal(object) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
      $(this.$refs.usermodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal: function closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.usermodal).modal("hide");
      $(this.$refs.userpasswordmodal).modal("hide");
    },
    createItem: function createItem() {
      this.resetModel();
      this.isUpdate = false;
      this.activeTab = "general";

      this.openModal({
        modifiedRoles: this.roles.map(function (item) {
          return { isSelected: false, id: item.id, name: item.name };
        }),
        modifiedPolicies: this.policies.map(function (item) {
          return { isSelected: false, id: item.id, name: item.name };
        }),
        modifiedProviders: [],
        modifiedCompanies: [],
        phoneNumber: ""
      });
    },
    updateItem: function updateItem(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, item, _loop, i, _loop2, _loop3, _loop4, index;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].getById(id);

              case 4:
                response = _context6.sent;
                item = response.data;

                _this5.isUpdate = true;
                _this5.activeTab = "general";
                item.modifiedRoles = [];

                _loop = function _loop(i) {
                  var selectedRole = item.roles.find(function (x) {
                    return x === _this5.roles[i].id;
                  });
                  item.modifiedRoles.push({
                    isSelected: selectedRole !== undefined && selectedRole !== null,
                    id: _this5.roles[i].id,
                    name: _this5.roles[i].name
                  });
                };

                for (i = 0; i < _this5.roles.length; i++) {
                  _loop(i);
                }

                item.modifiedPolicies = [];

                _loop2 = function _loop2(i) {
                  var selectedPolicy = item.policies.find(function (x) {
                    return x === _this5.policies[i].id;
                  });
                  item.modifiedPolicies.push({
                    isSelected: selectedPolicy !== undefined && selectedPolicy !== null,
                    id: _this5.policies[i].id,
                    name: _this5.policies[i].name
                  });
                };

                for (i = 0; i < _this5.policies.length; i++) {
                  _loop2(i);
                }

                if (item.providers.length === _this5.providers[0].items.length) {
                  item.modifiedProviders = _this5.providers.find(function (option) {
                    return option.group === "Select all";
                  }).items;
                } else {
                  item.modifiedProviders = [];

                  _loop3 = function _loop3(i) {
                    var selectedProvider = item.providers.find(function (x) {
                      return x === _this5.providers[0].items[i].id;
                    });
                    if (selectedProvider) {
                      item.modifiedProviders.push(_this5.providers[0].items[i]);
                    }
                  };

                  for (i = 0; i < _this5.providers[0].items.length; i++) {
                    _loop3(i);
                  }
                }

                if (item.companies.length === _this5.companies[0].items.length) {
                  item.modifiedCompanies = _this5.companies.find(function (option) {
                    return option.group === "Select all";
                  }).items;
                } else {
                  item.modifiedCompanies = [];

                  _loop4 = function _loop4(i) {
                    var selectedCompany = item.companies.find(function (x) {
                      return x === _this5.companies[0].items[i].id;
                    });
                    if (selectedCompany) {
                      item.modifiedCompanies.push(_this5.companies[0].items[i]);
                    }
                  };

                  for (i = 0; i < _this5.companies[0].items.length; i++) {
                    _loop4(i);
                  }
                }

                _this5.openModal(item);
                _context6.next = 22;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this5.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 22:
                _context6.prev = 22;

                _this5.isLoading = false;
                return _context6.finish(22);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[0, 19, 22, 25]]);
      }))();
    },
    resetPassword: function resetPassword(item) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this6.changePasswordModel = {
                  id: "",
                  changePasswordId: "",
                  password: ""
                };
                _this6.resetValidations();
                _context7.prev = 2;
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].forgotPassword({
                  id: item.id,
                  isSendEmail: false
                });

              case 5:
                response = _context7.sent;

                if (response.data) {
                  _this6.changePasswordModel.id = item.id;
                  _this6.changePasswordModel.changePasswordId = response.data;
                  $(_this6.$refs.userpasswordmodal).modal();
                } else {
                  _this6.$notification.error("User not found.");
                }
                _context7.next = 14;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this6.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }
                _context7.next = 14;
                return _this6.getAll();

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6, [[2, 9]]);
      }))();
    },
    openAuthModal: function openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      if (item.username != item.email) {
        this.auth.isMobile = true;
      } else {
        this.auth.isMobile = false;
      }
      $(this.$refs.useridpasswordmodal).modal();
    },
    submitAuth: function submitAuth() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this7.isSubmitted = true;
                _this7.$v.auth.$touch();

                if (!_this7.$v.auth.$error) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                _context8.prev = 4;

                _this7.isLoading = true;
                _context8.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].syncAuth(_this7.auth);

              case 8:
                _this7.$notification.success("Successfully synced.", {
                  title: "Success"
                });
                _this7.closeAuthModal();
                _context8.next = 12;
                return _this7.getAll();

              case 12:
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](4);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this7.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
                _context8.prev = 17;

                _this7.isLoading = false;
                return _context8.finish(17);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7, [[4, 14, 17, 20]]);
      }))();
    },
    closeAuthModal: function closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.useridpasswordmodal).modal("hide");
    },
    getAll: function getAll() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this8.isLoading = true;
                filter = "?page=" + _this8.table.pageNumber + "&size=" + _this8.table.pageSize;

                if (_this8.table.keyword !== null && _this8.table.keyword !== "") {
                  filter += "&search=" + _this8.table.keyword;
                }
                _context9.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].getAll(filter);

              case 6:
                response = _context9.sent;

                _this8.items = response.data;
                _this8.table.totalPages = response.totalPages;
                _this8.table.totalRecords = response.totalRecords;
                _context9.next = 15;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](0);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this8.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 15:
                _context9.prev = 15;

                _this8.isLoading = false;
                return _context9.finish(15);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8, [[0, 12, 15, 18]]);
      }))();
    },
    getRoles: function getRoles() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_identity_identityRoleService_js__["a" /* default */].getAllActive();

              case 2:
                _this9.roles = _context10.sent;

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this9);
      }))();
    },
    getPolicies: function getPolicies() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_identity_identityPolicyService_js__["a" /* default */].getAllActive();

              case 2:
                _this10.policies = _context11.sent;

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this10);
      }))();
    },
    getProviders: function getProviders() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var _providers;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_provider_providerService_js__["a" /* default */].getAllActive();

              case 2:
                _providers = _context12.sent;

                _this11.providers = [{ group: "Select all", items: _providers }];

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this11);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var _companies;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _companies = _context13.sent;

                _this12.companies = [{ group: "Select all", items: _companies }];

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this12);
      }))();
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this13.phoneCodes = _context14.sent;


                for (i = 0; i < _this13.phoneCodes.length; i++) {
                  item = _this13.phoneCodes[i];

                  item.label = "+" + item.dial;
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this13);
      }))();
    },
    searchPhoneCode: function searchPhoneCode(options, search) {
      var pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter(function (item) {
        return pattern.test(item.area) || pattern.test(item.country) || pattern.test(item.dial) || pattern.test(item.iata);
      });
    },
    getPredefinedLandingPages: function getPredefinedLandingPages() {
      var index = 1;
      this.landingPages = this.$router.options.routes.filter(function (el) {
        return el.children;
      }).map(function (val) {
        return val.children;
      }).flat().filter(function (f) {
        return f.meta && f.meta.title;
      }).map(function (x) {
        return {
          url: x.path,
          title: x.meta.title,
          label: index++ + ". " + x.meta.title + " (" + x.path + ")"
        };
      });
    },
    submit: function submit() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this14.isSubmitted = true;
                _this14.$v.model.$touch();

                if (!_this14.$v.model.$error) {
                  _context15.next = 4;
                  break;
                }

                return _context15.abrupt("return");

              case 4:
                _context15.prev = 4;

                _this14.isLoading = true;
                payload = _this14.constructPayload();

                if (!_this14.isUpdate) {
                  _context15.next = 13;
                  break;
                }

                _context15.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].update(payload);

              case 10:
                _this14.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context15.next = 16;
                break;

              case 13:
                _context15.next = 15;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].create(payload);

              case 15:
                _this14.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 16:
                _context15.next = 18;
                return _this14.$store.dispatch("user/removeProfile");

              case 18:
                _context15.next = 20;
                return _this14.getAll();

              case 20:
                _this14.closeModal();
                _context15.next = 26;
                break;

              case 23:
                _context15.prev = 23;
                _context15.t0 = _context15["catch"](4);

                if (_context15.t0.errors) {
                  for (index = 0; index < _context15.t0.errors.length; index++) {
                    _this14.$notification.error(_context15.t0.errors[index], { title: "Error" });
                  }
                }

              case 26:
                _context15.prev = 26;

                _this14.isLoading = false;
                if (_this14.isUpdate) window.location.reload();
                return _context15.finish(26);

              case 30:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this14, [[4, 23, 26, 30]]);
      }))();
    },
    sanitize: function sanitize(value) {
      if (typeof value !== "string") return value;

      return value.replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, "").trim();
    },
    constructPayload: function constructPayload() {
      var payload = {
        username: this.model.username && this.model.username.trim().length > 0 ? this.sanitize(this.model.username) : null,
        email: this.model.email && this.model.email.trim().length > 0 ? this.model.email.trim() : null,
        firstName: this.model.firstName && this.model.firstName.trim().length > 0 ? this.model.firstName.trim() : null,
        lastName: this.model.lastName && this.model.lastName.trim().length > 0 ? this.model.lastName.trim() : null,
        middleName: this.model.middleName && this.model.middleName.trim().length > 0 ? this.model.middleName.trim() : null,
        phoneNumber: this.model.phoneNumber && this.model.phoneNumber.trim().length > 0 ? this.sanitize(this.model.phoneNumber) : null,
        phoneCode: this.model.phoneCode && this.model.phoneCode.trim().length > 0 ? this.model.phoneCode.trim() : null,
        imageUri: this.model.imageUri && this.model.imageUri.trim().length > 0 ? this.model.imageUri.trim() : null,
        landingPage: this.model.landingPage && this.model.landingPage.trim().length > 0 ? this.model.landingPage.trim() : null,
        roles: this.model.modifiedRoles.filter(function (x) {
          return x.isSelected;
        }).map(function (x) {
          return x.id;
        }),
        policies: this.model.modifiedPolicies.filter(function (x) {
          return x.isSelected;
        }).map(function (x) {
          return x.id;
        }),
        providers: [],
        companies: []
      };

      if (this.model.modifiedProviders && this.model.modifiedProviders.length > 0) {
        payload.providers = this.model.modifiedProviders.map(function (x) {
          return x.id;
        });
      }

      if (this.model.modifiedCompanies && this.model.modifiedCompanies.length > 0) {
        payload.companies = this.model.modifiedCompanies.map(function (x) {
          return x.id;
        });
      }

      if (this.isUpdate) {
        payload.id = this.model.id;
      } else {
        payload.password = this.model.password && this.model.password.trim().length > 0 ? this.model.password.trim() : null;
      }

      return payload;
    },
    changeStatus: function changeStatus(item) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this15.isLoading = true;

                if (!item.isActive) {
                  _context16.next = 8;
                  break;
                }

                _context16.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].reactivate({ id: item.id });

              case 5:
                _this15.$notification.success("Successfully reactivated."), { title: "Success" };
                _context16.next = 11;
                break;

              case 8:
                _context16.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].deactivate({ id: item.id });

              case 10:
                _this15.$notification.success("Successfully deactivated.", {
                  title: "Success"
                });

              case 11:
                _context16.next = 13;
                return _this15.$store.dispatch("user/removeProfile");

              case 13:
                _context16.next = 15;
                return _this15.getAll();

              case 15:
                _context16.next = 20;
                break;

              case 17:
                _context16.prev = 17;
                _context16.t0 = _context16["catch"](0);

                if (_context16.t0.errors) {
                  for (index = 0; index < _context16.t0.errors.length; index++) {
                    _this15.$notification.error(_context16.t0.errors[index], { title: "Error" });
                  }
                }

              case 20:
                _context16.prev = 20;

                _this15.isLoading = false;
                return _context16.finish(20);

              case 23:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this15, [[0, 17, 20, 23]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this16.isLoading = true;
                _context17.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].delete(_this16.itemToBeDeleted.id);

              case 4:
                _this16.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context17.next = 7;
                return _this16.$store.dispatch("user/removeProfile");

              case 7:
                _context17.next = 9;
                return _this16.getAll();

              case 9:
                _context17.next = 14;
                break;

              case 11:
                _context17.prev = 11;
                _context17.t0 = _context17["catch"](0);

                if (_context17.t0.errors) {
                  for (index = 0; index < _context17.t0.errors.length; index++) {
                    _this16.$notification.error(_context17.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context17.prev = 14;

                _this16.isLoading = false;
                return _context17.finish(14);

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this16, [[0, 11, 14, 17]]);
      }))();
    },
    changePassword: function changePassword() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _this17.isSubmitted = true;
                _this17.$v.changePasswordModel.$touch();

                if (!_this17.$v.changePasswordModel.$error) {
                  _context18.next = 4;
                  break;
                }

                return _context18.abrupt("return");

              case 4:
                _context18.prev = 4;

                _this17.isLoading = true;
                debugger;
                _context18.next = 9;
                return __WEBPACK_IMPORTED_MODULE_6__services_master_identity_identityUserService_js__["a" /* default */].changePassword(_this17.changePasswordModel);

              case 9:
                _this17.$notification.success("Password changed successfully.", {
                  title: "Success"
                });
                _this17.closeModal();
                _context18.next = 16;
                break;

              case 13:
                _context18.prev = 13;
                _context18.t0 = _context18["catch"](4);

                if (_context18.t0.errors) {
                  for (index = 0; index < _context18.t0.errors.length; index++) {
                    _this17.$notification.error(_context18.t0.errors[index], { title: "Error" });
                  }
                }

              case 16:
                _context18.prev = 16;

                _this17.isLoading = false;
                return _context18.finish(16);

              case 19:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this17, [[4, 13, 16, 19]]);
      }))();
    },
    isHimSelf: function isHimSelf(username) {
      return this.profile.username === username;
    },
    userItemContainSelector: function userItemContainSelector(user) {
      return user.selectors.Companies && user.selectors.Companies.length > 0 || user.selectors.Providers && user.selectors.Providers.length > 0;
    },
    printSelectorIndicator: function printSelectorIndicator(selectors) {
      var labels = [];

      if (selectors) {
        if (selectors.Providers && selectors.Providers.length > 0) {
          labels.push(selectors.Providers.length + " provider(s)");
        }
        if (selectors.Companies && selectors.Companies.length > 0) {
          labels.push(selectors.Companies.length + " company(s)");
        }
      }

      return labels.length > 0 ? labels.join(", ") : "N/A";
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/36.80a1332cf606059d44e6.js